// Copyright (c) 2020 WiseTime. All rights reserved.

import { concat, Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import * as Actions from "../actions"
import * as TagsSlice from "../slice"
import { SearchTagsRequest, SearchTagsResponseShallow } from "generated/legebill/site/tag/v4/tag_pb"
import { grpc } from "app/rpc/executor"
import { tagServiceClient } from "app/rpc/client"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type SearchTagsShallowRpc = (request: SearchTagsRequest) => Observable<SearchTagsResponseShallow>

export const searchTagsShallow = (searchTagsShallowRpc: SearchTagsShallowRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.searchTagsShallow.match),
      mergeMap(({ payload }) => of(payload)
        .pipe(
          mergeMap(searchTagsShallowRpc),
          map(t => t.toObject()),
          map(response => TagsSlice.setResultTagsShallow({ searchString: payload.getSearchText(), response })),
          catchError(_ => concat(
            of(TagsSlice.resetResultTagsShallow()),
            of(showSnackBar({
              message: t({
                id: "msg_search_tags_failed",
                message: "Failed to search for tags. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com."
              }),
              messageType: "ERROR",
            }))
          )),
        )
      ),
    )

const searchTagsShallowRpc = (request: SearchTagsRequest): Observable<SearchTagsResponseShallow> =>
  grpc(() => tagServiceClient.searchTagsShallow(request, null))

export default searchTagsShallow(searchTagsShallowRpc)
